import { render } from "./StoreConfigurationGeneralInformations.vue?vue&type=template&id=5b8630ec"
import script from "./StoreConfigurationGeneralInformations.vue?vue&type=script&lang=js"
export * from "./StoreConfigurationGeneralInformations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__